import { useMutation } from '@apollo/client';
import { UPDATE_REPORT_MUTATION } from '../operations';

export const useUpdateReport = () => {
  const [updateReportMutation, { data, loading, error }] = useMutation(UPDATE_REPORT_MUTATION);

  const updateReport = async (report) => {
    if (!report) throw new Error('No report found to update');

    const input = {
      name: report.name,
      description: report.description,
      pages: report.pages,
    };

    await updateReportMutation({
      variables: {
        id: report.id,
        input,
      },
    });
  };

  return { updateReport, updatedReport: data?.updateSmartReport || null, loading, error };
};
